<ng-container [formGroup]="formGroup">
  <div class="start-date">
    <mat-form-field>
      <mat-label>Date de prise d'effet</mat-label>
      <input matInput formControlName="startDate" [matDatepicker]="startDatePicker" />
      <mat-hint>JJ/MM/AAAA</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #startDatePicker></mat-datepicker>
    </mat-form-field>
    <svg
      lucideCircleQuestionMark
      matTooltip="La grille sera proposée pour les nouveau contrat à partir de cette date et tant qu'aucune autre grille plus récente ne vient la remplacer"
      matTooltipPosition="above"
    ></svg>
  </div>

  <table>
    <tr>
      <th>Qualification</th>
      <th>Salaire horaire brut</th>
    </tr>
    @for (entry of formGroup.controls.entries.controls; track $index) {
      <tr [formGroup]="entry">
        <td>
          <span class="qualification-level">{{ entry.controls.qualificationLevel.value }}</span>
        </td>
        <td>
          <mat-form-field class="gross-hourly-salary">
            <mat-label>Salaire horaire brut</mat-label>
            <input
              matInput
              formControlName="grossHourlySalary"
              type="number"
              step="0.01"
              class="right-align"
              min="0"
            />
            <span matTextSuffix>€</span>
          </mat-form-field>
        </td>
      </tr>
    }
  </table>
</ng-container>
